import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFire3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFire3"><Path d="M18.0108 7.85568C19.2072 8.99339 19.7235 10.4625 19.9171 11.996C21.1455 21.6401 8.36745 25.0988 4.64692 16.9079C3.54484 14.4742 3.88738 12.0702 5.39653 9.87883C5.90785 9.13684 6.54328 8.46411 7.19361 7.84084C8.92615 6.18374 10.619 4.85685 11.3636 2.25C14.6667 4.38889 15.2 8.66667 15.2 10.8056C15.2 10.8056 17.4586 8.63324 18.0108 7.85568Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFire3;
